import { jsx as r, jsxs as o } from "react/jsx-runtime";
import { ItemContainer as c, Container as m, DiscListContainer as d, NumberListContainer as l, AlphaListContainer as h } from "./styled.js";
const L = ({ type: n, items: s, getProps: i }) => {
  const e = s.map((a, t) => /* @__PURE__ */ r(c, { ...i ? i(t) : {}, children: a }, t));
  return /* @__PURE__ */ o(m, { children: [
    n === "disc" && /* @__PURE__ */ r(d, { children: e }),
    n === "number" && /* @__PURE__ */ r(l, { children: e }),
    n === "alpha" && /* @__PURE__ */ r(h, { children: e })
  ] });
};
export {
  L as List,
  L as default
};
